import React from 'react'
import SocialMediaDetail from './SocialMediaDetail'

const Profilesocials = ({ Socials }: any) => {
  return (
    <>
      {Socials.map((media: any, idx: number) => {
        const keys = Object.keys(media)[0]
        return media[keys] !== '' && <SocialMediaDetail key={idx} keys={keys} media={media} />
      })}
    </>
  )
}

export default Profilesocials
